import { registerLocaleData } from '@angular/common';
import { HttpClientModule } from '@angular/common/http';
import localeFr from '@angular/common/locales/fr';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { MsalModule, MsalRedirectComponent } from '@azure/msal-angular';
import { TRANSLATE_SERVICE } from '@dlw-int-mwi/eps-common';
import { FlowModule } from 'app/modules/flow/flow.module';
import { OrderModule } from 'app/modules/order/order.module';
import { RelocationModule } from 'app/modules/relocation/relocation.module';
import { RelocationsModule } from 'app/modules/relocations/relocations.module';
import { StockCountModule } from 'app/modules/stock-count/stock-count.module';
import { NgcCookieConsentConfig, NgcCookieConsentModule } from 'ngx-cookieconsent';
import { ToastrModule } from 'ngx-toastr';
import { AppRoutingModule } from './app-routing.module';
import { AuthenticationModule } from './core/authentication/authentication.module';
import { CoreModule } from './core/core.module';
import { AdminRoutingModule } from './modules/admin/admin-routing.module';
import { AdminModule } from './modules/admin/admin.module';
import { BlankReceiptModule } from './modules/blank-receipt/blank-receipt.module';
import { CalendarModule } from './modules/calendar/calendar.module';
import { CCRModule } from './modules/ccr/ccr.module';
import { DashboardModule } from './modules/dashboard/dashboard.module';
import { FlowsModule } from './modules/flows/flows.module';
import { HomeMarketBonusModule } from './modules/home-market-bonus/home-market-bonus.module';
import { InvoicesModule } from './modules/invoices/invoices.module';
import { OrdersModule } from './modules/orders/orders.module';
import { ReportModule } from './modules/report/report.module';
import { SelectCustomerModule } from './modules/select-customer/select-customer.module';
import { ServiceModule } from './modules/service/service.module';
import { SharedModule } from './shared';
import { AppComponent } from './shared/app/app.component';
import { TranslationAdapterService } from './shared/eps-common/translation-adapter.service';

registerLocaleData(localeFr);

const cookieConfig: NgcCookieConsentConfig = {
  position: 'bottom-right',
  theme: 'classic',
  container: document.getElementById('content'),
  palette: {
    popup: {
      background: '#CBE4EF',
      text: '#004868',
    },
    button: {
      background: '#04ACF7',
      text: '#ffffff',
    },
  },
  revokable: false,
  autoOpen: false,
  cookie: {
    domain: undefined, // 'europoolsystem.com' // or 'your.domain.com' // it is mandatory to set a domain, for cookies to work properly (see https://goo.gl/S2Hy2A)
  },
};

@NgModule({
  declarations: [AppComponent],
  imports: [
    AuthenticationModule,
    BrowserModule,
    BrowserAnimationsModule,
    FormsModule,
    HttpClientModule,
    AdminRoutingModule,
    CoreModule,
    OrdersModule,
    OrderModule,
    FlowsModule,
    FlowModule,
    CCRModule,
    AdminModule,
    SharedModule,
    DashboardModule,
    HomeMarketBonusModule,
    ToastrModule.forRoot(),
    SelectCustomerModule,
    InvoicesModule,
    SelectCustomerModule,
    CalendarModule,
    ReportModule,
    ServiceModule,
    BlankReceiptModule,
    RelocationModule,
    RelocationsModule,
    NgcCookieConsentModule.forRoot(cookieConfig),
    StockCountModule,
    MsalModule,
    AppRoutingModule, // must be last so that fallback route is not chosen
  ],
  providers: [
    { provide: TRANSLATE_SERVICE, useExisting: TranslationAdapterService }
  ],
  bootstrap: [AppComponent, MsalRedirectComponent],
})
export class AppModule { }
